import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';
import { VerificationCodeResponse } from '../components/login/login.model';

@Injectable({
  providedIn: 'root',
})
export class CompareVcodeService extends Mutation<VerificationCodeResponse> {
  document = gql`
    query CompareVcode2 ($email: String!, $vcode: Int!) {
        compareVcode(email: $email, vcode: $vcode)
    }
    `;
  }
